import axios from "axios";
import Cookies from "js-cookie";
import { TOKEN_COOKIE_NAME } from "../store/authSlice";

console.debug('[TC:boot] globalAdminApi — REACT_APP_API_URL:', process.env.REACT_APP_API_URL || '(not set — falling back to relative URLs)');

const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: { "Content-Type": "application/json" },
  withCredentials: true,
});

client.interceptors.request.use((config) => {
  const token = Cookies.get(TOKEN_COOKIE_NAME);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function getGlobalDashboard() {
  return client.get("/api/v1/admin/global-dashboard").then((r) => r.data);
}

export function searchTenantUsers(tenantId, q, role, signal) {
  const params = new URLSearchParams();
  if (q) params.set("q", q);
  if (role && role !== "all") params.set("role", role);
  return client
    .get(`/api/v1/admin/global-dashboard/${tenantId}/users?${params.toString()}`, { signal })
    .then((r) => r.data);
}

export async function startImpersonation(tenantId, userId, role) {
  const { data: authorization } = await client.post("/api/v1/admin/impersonate", { tenantId, userId, role });
  const form = new URLSearchParams({
    grant_type: "urn:ietf:params:oauth:grant-type:token-exchange",
    subject_token: authorization.subject_token,
    subject_token_type: "urn:ietf:params:oauth:token-type:jwt",
    actor_token: authorization.actor_token,
    actor_token_type: "urn:ietf:params:oauth:token-type:jwt",
    requested_token_type: "urn:ietf:params:oauth:token-type:access_token",
    audience: "training-center-api", scope: "impersonation", client_id: "training-center-web",
  });
  const { data } = await client.post("/api/v1/oauth/token", form.toString(), {
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
  return { ...data, token: data.access_token };
}

export function getAuditLogStats(days = 7) {
  return client.get("/api/v1/admin/audit-log/stats", { params: { days } }).then((r) => r.data);
}

export function getAuditLog({ search = "", action = "all", tenant = "all", environment = "all", status = "all", days = 7, page = 0, size = 50 } = {}) {
  return client
    .get("/api/v1/admin/audit-log", { params: { search, action, tenant, environment, status, days, page, size } })
    .then((r) => r.data);
}

export function getAuditLogExportUrl({ search = "", action = "all", tenant = "all", environment = "all", status = "all", days = 30 } = {}) {
  const p = new URLSearchParams({ search, action, tenant, environment, status, days });
  const base = process.env.REACT_APP_API_URL || "";
  return `${base}/api/v1/admin/audit-log/export?${p.toString()}`;
}

export function getSystemHealth() {
  return client.get("/api/v1/admin/system-health").then((r) => r.data);
}

export function endImpersonationAudit(payload) {
  return client.post("/api/v1/admin/impersonate/end", payload).then((r) => r.data);
}

export function recheckAhaSending() {
  return client.post("/api/v1/admin/system-health/aha/recheck").then((r) => r.data);
}
